import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import cookies from "js-cookie";
import logoImage from "../../img/logo.png";
import threeDotIcon from "../../img/hamburger.png";
import DropdownMain from "../dropdown/dropdownMain";
import CountrySelector from "../countrySelector/CountrySelector";
import "./mainHeader.css";

// Inline SVG icons
const FlaskConical = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2" />
    <path d="M8.5 2h7" />
    <path d="M7 16h10" />
  </svg>
);

const BadgeCheck = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.78 4.78 4 4 0 0 1-6.74 0 4 4 0 0 1-4.78-4.78 4 4 0 0 1 0-6.74Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

const Users = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const BarChart3 = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M3 3v18h18" />
    <path d="M18 17V9" />
    <path d="M13 17V5" />
    <path d="M8 17v-3" />
  </svg>
);

const Sparkles = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
    <path d="M5 3v4" />
    <path d="M19 17v4" />
    <path d="M3 5h4" />
    <path d="M17 19h4" />
  </svg>
);

const MonitorSmartphone = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8" />
    <path d="M10 19v-4" />
    <path d="M6 19h8" />
    <rect width="6" height="10" x="16" y="11" rx="1" />
  </svg>
);

const Landmark = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="3" x2="21" y1="22" y2="22" />
    <line x1="6" x2="6" y1="18" y2="11" />
    <line x1="10" x2="10" y1="18" y2="11" />
    <line x1="14" x2="14" y1="18" y2="11" />
    <line x1="18" x2="18" y1="18" y2="11" />
    <polygon points="12 2 20 7 4 7 12 2" />
    <line x1="2" x2="22" y1="18" y2="18" />
  </svg>
);

const ChevronDown = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
);

const XIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

/* One source of truth for the dropdown rows */
const dropdownItemClass =
  "glass-option flex w-full cursor-pointer items-start rounded-md px-3 py-2 text-left text-white focus-visible:outline-none";

const ProductRow = ({ icon: Icon, title, description }) => (
  <>
    <Icon
      size={16}
      className="mr-2 mt-0.5 h-4 w-4 flex-none text-gray-400"
      aria-hidden="true"
    />
    <span className="min-w-0">
      <span className="block text-sm leading-tight">{title}</span>
      <span className="mt-0.5 block text-xs leading-snug text-gray-400">
        {description}
      </span>
    </span>
  </>
);

const MainHeader = () => {
  const location = useLocation();
  const pathname = location ? location.pathname : "/";

  const [scrolled, setScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(null);
  const [userDetail, setUserDetail] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showSidebarMenu, setShowSidebarMenu] = useState(false);
  const dropdownRef = useRef(null);

  const [canHover, setCanHover] = useState(false);
  const closeTimer = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const headerRef = useRef(null);

  const isActive = (href) =>
    href === "/" ? pathname === "/" : pathname.startsWith(href);

  const productRoutes = ["/search-table", "/remote"];
  const isProductActive = productRoutes.some((r) => pathname.startsWith(r));

  useEffect(() => {
    setCanHover(
      window.matchMedia("(hover: hover) and (pointer: fine)").matches
    );

    const mobile = window.matchMedia("(max-width: 767.98px)");
    const sync = () => setIsMobile(mobile.matches);
    sync();
    mobile.addEventListener("change", sync);

    return () => {
      mobile.removeEventListener("change", sync);
      if (closeTimer.current) clearTimeout(closeTimer.current);
    };
  }, []);

  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const publish = () => {
      document.documentElement.style.setProperty(
        "--header-h",
        `${el.offsetHeight}px`
      );
    };
    const observer = new ResizeObserver(publish);
    observer.observe(el);
    publish();
    return () => observer.disconnect();
  }, []);

  const openProductsOnHover = () => {
    if (!canHover) return;
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setIsDropdownOpen(true);
  };

  const closeProductsOnHover = () => {
    if (!canHover) return;
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setIsDropdownOpen(false), 140);
  };

  const toggleSidebar = () => {
    setShowSidebarMenu(!showSidebarMenu);
  };

  const closeSidebar = () => setShowSidebarMenu(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const token = cookies.get("access");
      const userData = cookies.get("userDetails");
      setShowLogin(!token);
      setIsLoggedIn(!!token);
      if (userData) {
        try {
          setUserDetail(JSON.parse(userData));
        } catch (e) {
          setUserDetail(userData);
        }
      }
    }
  }, []);

  useEffect(() => {
    setIsDropdownOpen(false);
    setShowSidebarMenu(false);
  }, [pathname]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key !== "Escape") return;
      setIsDropdownOpen(false);
      setShowSidebarMenu(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  useEffect(() => {
    if (showSidebarMenu) {
      document.body.classList.add("body-scroll-lock");
    } else {
      document.body.classList.remove("body-scroll-lock");
    }

    return () => {
      document.body.classList.remove("body-scroll-lock");
    };
  }, [showSidebarMenu]);

  const handleLoginURL = () => {
    window.location.href =
      process.env.REACT_APP_PUBLIC_TESTINGLOGIN_NAVBAR_ROUTE_URL ||
      (process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "") + "/login";
  };

  const handleSignupURL = () => {
    window.location.href =
      process.env.REACT_APP_PUBLIC_TESTINGSIGNUP_NAVBAR_ROUTE_URL ||
      (process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "") + "/sign-up";
  };

  return (
    <div
      ref={headerRef}
      className={`main_header_common fixed w-full top-0 left-0 right-0 shadow-md z-[99999] ${
        scrolled ? "header_scrolled" : ""
      }`}
    >
      <div className="relative z-30">
        <nav className="navbar container mx-auto flex justify-between items-center gap-3 py-4">
          <div className="flex items-center">
            <button
              type="button"
              className="mt-1 mr-2 grid h-9 w-9 place-items-center rounded-full transition-colors hover:bg-white/10 md:!hidden"
              aria-label={showSidebarMenu ? "Close menu" : "Open menu"}
              aria-expanded={showSidebarMenu}
              aria-controls="primary-menu"
              onClick={toggleSidebar}
            >
              {showSidebarMenu ? (
                <XIcon size={20} className="text-white" />
              ) : (
                <img
                  src={threeDotIcon}
                  alt=""
                  width={20}
                  height={20}
                  className="invert"
                />
              )}
            </button>
            <Link
              to="#"
              onClick={() => {
                window.location.href =
                  process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/";
              }}
              aria-label="Crosslinker Labs home"
              className="shrink-0"
            >
              <img
                src={logoImage}
                alt="Crosslinker Labs"
                width={220}
                height={65}
                className="nav_logo object-fill height65 w-[170px] lg:w-[220px] header_logo"
              />
            </Link>
          </div>

          <div className="flex justifyEnd items-center w-fullMob flex-1 min-w-0 tabmobwidht justify-between space-x-4 flexStart">
            <ul
              id="primary-menu"
              aria-hidden={isMobile && !showSidebarMenu ? true : undefined}
              className={`lg:flex md:flex md:space-x-6 bgMob pt10
  md:flex-1 md:justify-center md:ml-6 lg:ml-10
  space-x-0 lg:space-x-6 md:space-y-0 space-y-2 lg:space-y-0
  text-[#ebebeb]
  md:relative lg:relative
  fixed w-full left-0 md:left-0 lg:left-0
  md:w-auto lg:w-auto
  md:top-0 lg:top-0
  md:h-auto lg:h-auto
  pl-3 md:pl-0 lg:pl-0
  ${showSidebarMenu ? "menu-open block" : "hidden"}
  md:flex lg:flex`}
            >
              <li className="font-medium mL10">
                <Link
                  to="#"
                  className="nav_link"
                  aria-current={isActive("/") ? "page" : undefined}
                  onClick={() => {
                    closeSidebar();
                    window.location.href =
                      process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/";
                  }}
                >
                  Home
                </Link>
              </li>
              <li className="font-medium mL10">
                <Link
                  to="#"
                  className="nav_link"
                  aria-current={isActive("/about-us") ? "page" : undefined}
                  onClick={() => {
                    closeSidebar();
                    window.location.href =
                      process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/";
                  }}
                >
                  About
                </Link>
              </li>
              <li
                ref={dropdownRef}
                className="mL10 pr20 relative"
                onMouseEnter={openProductsOnHover}
                onMouseLeave={closeProductsOnHover}
              >
                <button
                  className={`nav_link font-medium flex items-center gap-1 ${
                    isProductActive ? "is-active" : ""
                  }`}
                  aria-haspopup="true"
                  aria-expanded={isDropdownOpen}
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Products
                  <ChevronDown
                    size={16}
                    aria-hidden="true"
                    className={`transition-transform duration-200 ${
                      isDropdownOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isDropdownOpen && (
                  <div
                    role="menu"
                    className="nav-products-menu glass-panel absolute top-full md:mt-2 lg:mt-2 textWhite text-white mt-2 z-50 p-2 rounded-md w-[320px] md:w-[360px] right-0 overflow-hidden bg-[#272737] border border-pink-500"
                  >
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        closeSidebar();
                        setIsDropdownOpen(false);
                        const access = cookies.get("access");
                        if (!access) {
                          window.location.href =
                            (process.env
                              .REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL ||
                              "") + "/login";
                        } else {
                          window.location.href =
                            (process.env
                              .REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL ||
                              "") + "/search-table";
                        }
                      }}
                      aria-current={
                        isActive("/search-table") ? "page" : undefined
                      }
                      className={`${dropdownItemClass} ${
                        isActive("/search-table") ? "is-selected" : ""
                      }`}
                    >
                      <ProductRow
                        icon={FlaskConical}
                        title="Testing"
                        description="Book instrument time at labs worldwide"
                      />
                    </Link>
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        closeSidebar();
                        setIsDropdownOpen(false);
                        const access = cookies.get("access");
                        if (!access) {
                          window.location.href =
                            (process.env
                              .REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL ||
                              "") + "/login";
                        } else {
                          window.location.href =
                            process.env
                              .REACT_APP_PUBLIC_CERTIFICATION_NAVBAR_ROUTE_URL ||
                            "#";
                        }
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow
                        icon={BadgeCheck}
                        title="Certification"
                        description="Compliance and certification workflows"
                      />
                    </Link>
                    <Link
                      to="/"
                      onClick={() => {
                        closeSidebar();
                        setIsDropdownOpen(false);
                        if (process.env.REACT_APP_PUBLIC_PROJECTS_NAVBAR_ROUTE_URL) {
                          window.location.href = process.env.REACT_APP_PUBLIC_PROJECTS_NAVBAR_ROUTE_URL;
                        }
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow
                        icon={Users}
                        title="Collaborate"
                        description="Run joint research projects in one place"
                      />
                    </Link>
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        closeSidebar();
                        setIsDropdownOpen(false);
                        const access = cookies.get("access");
                        if (!access) {
                          alert("Please log in to access this section.");
                          return;
                        }
                        window.location.href =
                          process.env
                            .REACT_APP_PUBLIC_SERVICES_NAVBAR_ROUTE_URL || "#";
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow
                        icon={BarChart3}
                        title="Analyze & Report"
                        description="Turn raw results into shareable reports"
                      />
                    </Link>
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        closeSidebar();
                        setIsDropdownOpen(false);
                        const access = cookies.get("access");
                        if (!access) {
                          alert("Please log in to access this section.");
                          return;
                        }
                        window.location.href =
                          process.env.REACT_APP_PUBLIC_ASKAI_PROD_URL || "#";
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow
                        icon={Sparkles}
                        title="Biz Dev"
                        description="AI matchmaking for labs and buyers"
                      />
                    </Link>
                    <Link
                      to="/remote"
                      aria-current={isActive("/remote") ? "page" : undefined}
                      onClick={() => {
                        closeSidebar();
                        setIsDropdownOpen(false);
                      }}
                      className={`${dropdownItemClass} ${
                        isActive("/remote") ? "is-selected" : ""
                      }`}
                    >
                      <ProductRow
                        icon={MonitorSmartphone}
                        title="Remote"
                        description="Operate instruments without leaving your desk"
                      />
                    </Link>
                    <button
                      type="button"
                      onClick={() => {
                        const access = cookies.get("access");
                        if (!access) {
                          alert("Please log in to access this section.");
                          setIsDropdownOpen(false);
                          return;
                        }

                        const planName = cookies.get("planName");
                        if (planName === "true") {
                          window.open(
                            process.env.REACT_APP_PUBLIC_GOVT_URL,
                            "_blank"
                          );
                          setIsDropdownOpen(false);
                        } else {
                          alert(
                            "Only Premium and Plus plan users can access this section."
                          );
                          setIsDropdownOpen(false);
                        }
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow
                        icon={Landmark}
                        title="Government"
                        description="Premium and Plus plans only"
                      />
                    </button>
                  </div>
                )}
              </li>
              <li className="font-medium mL10">
                <Link
                  to="#"
                  className="nav_link"
                  aria-current={
                    isActive("/case-studies") ? "page" : undefined
                  }
                  onClick={() => {
                    closeSidebar();
                    window.location.href =
                      process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/";
                  }}
                >
                  Resources
                </Link>
              </li>
              <li className="font-medium mL10">
                <a
                  href="https://crosslinker.us/pricing-plans"
                  className="nav_link"
                  aria-current={
                    isActive("/pricing-plans") ? "page" : undefined
                  }
                  onClick={closeSidebar}
                >
                  Pricing
                </a>
              </li>
            </ul>

            <div className="flex items-center gap-3 mL10">
              <CountrySelector />

              {!isLoggedIn && showLogin !== null && showLogin && (
                <div className="flex items-center space-x-3">
                  <Link
                    to="#"
                    onClick={() => handleLoginURL()}
                    className="btn-login-header"
                  >
                    Log In
                  </Link>
                  <Link
                    to="#"
                    onClick={() => handleSignupURL()}
                    className="btn-signup-header"
                  >
                    Sign Up
                    <span className="text-sm">→</span>
                  </Link>
                </div>
              )}
              {isLoggedIn && (
                <DropdownMain userData={userDetail} />
              )}
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MainHeader;
